<template>
  <div class="dash-root">
    <vue-element-loading :active="appLoading" spinner="bar-fade-scale" color="#3ea56e" size="128" is-full-screen />
    <v-snackbar v-model="showsnackbar" color="#333333" right :timeout="5000">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    
    <div v-else>
      <div class="dash-page-header">
        <div>
          <p class="dash-page-header__eyebrow">Home Management</p>
          <h1 class="dash-page-header__title">Middle Sliders</h1>
        </div>
        <div class="dash-page-header__actions">
          <v-btn class="btn-submit" @click="dialog = true" depressed>
            <v-icon left size="20">mdi-plus</v-icon> Add Slider
          </v-btn>
        </div>
      </div>

      <div class="slider-grid mt-6">
        <v-card v-for="(item, i) in user" :key="i" class="modern-card slider-card" elevation="0">
          <div v-viewer class="slider-image-wrapper">
            <img class="slider-image" :src="mediaUURL + item.image" />
          </div>
          <div class="slider-content">
            <div class="slider-link text-truncate" :title="item.link">{{ item.link }}</div>
            <div class="slider-actions">
              <v-btn
                small
                outlined
                color="#0284c7"
                class="flex-grow-1 mr-2"
                style="border-radius: 6px; text-transform: none; font-family: poppinsmedium;"
                @click="editSlider(item)"
              >
                Edit
              </v-btn>
              <v-btn
                small
                outlined
                color="#ef4444"
                class="flex-grow-1"
                style="border-radius: 6px; text-transform: none; font-family: poppinsmedium;"
                @click="item.delete = true"
              >
                Delete
              </v-btn>
            </div>
          </div>
          
          <v-dialog v-model="item.delete" max-width="400px" content-class="modern-dialog">
            <v-card class="modern-dialog-card">
              <v-card-title class="modern-dialog-header">
                Confirm Deletion
              </v-card-title>
              <v-card-text class="modern-dialog-body pt-4">
                Are you sure you want to delete this slider? This action cannot be undone.
              </v-card-text>
              <v-card-actions class="modern-dialog-actions">
                <v-spacer></v-spacer>
                <v-btn text class="btn-cancel" @click="item.delete = false">Cancel</v-btn>
                <v-btn class="btn-submit" style="background: #ef4444 !important; box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2) !important;" @click="deleteItem(item)" depressed>Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </div>

      <v-dialog v-model="dialog" persistent max-width="600px" content-class="modern-dialog">
        <v-card class="modern-dialog-card">
          <v-form v-model="addslider" ref="addcat">
            <v-card-title class="modern-dialog-header">
              Add New Slider
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogclose()" class="modern-dialog-close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="modern-dialog-body pt-6">
              <v-text-field
                v-model="link"
                label="Redirect Link"
                :rules="[rules.required]"
                required
                outlined
                dense
                class="modern-input mb-4"
              ></v-text-field>
              
              <div class="image-upload-wrapper">
                <ImageComp
                  :singleImage="null"
                  :pageId="'new'"
                  @stepper="winStepper"
                  :height="'300'"
                  :width="'1252'"
                  :heading="'Upload Slider Image (1252 * 300)'"
                  :componentType="'sliderImage'"
                />
              </div>
            </v-card-text>
            <v-card-actions class="modern-dialog-actions">
              <v-spacer></v-spacer>
              <v-btn text class="btn-cancel" @click="dialogclose()">Cancel</v-btn>
              <v-btn
                class="btn-submit"
                :disabled="!addslider"
                @click="add()"
                depressed
              >
                Save Slider
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editdialog" max-width="600px" content-class="modern-dialog">
        <v-card class="modern-dialog-card">
          <v-card-title class="modern-dialog-header">
            Edit Slider
            <v-spacer></v-spacer>
            <v-btn icon @click="editdialog = false" class="modern-dialog-close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="modern-dialog-body pt-6">
            <v-text-field
              v-model="editingitem.link"
              label="Redirect Link"
              :rules="[rules.required]"
              required
              outlined
              dense
              class="modern-input mb-4"
            ></v-text-field>
            
            <div class="image-upload-wrapper">
              <ImageComp
                :singleImage="editingitem.image"
                :pageId="editingitem._id"
                @stepper="winStepper"
                :height="'300'"
                :width="'1252'"
                :heading="'Upload Slider Image (1252 * 300)'"
                :componentType="'sliderImage'"
              />
            </div>
          </v-card-text>
          <v-card-actions class="modern-dialog-actions">
            <v-spacer></v-spacer>
            <v-btn text class="btn-cancel" @click="editdialog = false">Cancel</v-btn>
            <v-btn class="btn-submit" @click="edit()" depressed>Save Changes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ImageComp from "@/components/Common/singleImage";
export default {
  components: {
    ImageComp,
  },
  data() {
    return {
      checkbox: true,
      file: null,
      sliderMobileImage: null,
      sliderImage: null,
      showsnackbar: false,
      editingitem: [],
      msg: null,
      pages: 0,
      widthOfCard: "250px",
      link: "",
      appLoading: false,
      currentPage: 1,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      ratings: [],
      dialog: false,
      editdialog: false,
      ServerError: false,
      user: [],
      addslider: false,
      imgId: "",
      images: [],
      rules: {
        required: (value) =>
          /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test(
            value
          ) || "Must be link",
        min: (v) => v.length >= 10 || "Min 10 characters",
      },
      Rules: [(value) => !!value || "Required."],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.type == "sliderImage") {
        this.sliderImage = window_data.selectedFiles;
      }
      //   if (window_data.type == "sliderMobileImage") {
      //   this.sliderMobileImage = window_data.selectedFiles;
      // }
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/home/slider/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // istop:this.checkbox,
          count: this.count,
          page: this.currentPage,
          ismiddle: true,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          // var temp = [];
          // for (var i = 0; i < this.user.length; i++) {
          //   if (this.user[i].istop == true) {
          //     var ty = this.user[i];
          //     temp.push(ty);
          //     this.images.push(ty.image);
          //   }
          // }
          // this.user = temp;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    add() {
      var data = {};
      data["link"] = this.link;
      data["ismiddle"] = true;
      data["istop"] = false;
      axios({
        url: "/home/slider/add",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status) {
            this.imgId = response.data.id;
            if (this.sliderImage) {
              this.uploadImage(this.imgId);
            }
            // if (this.sliderMobileImage) {
            //   this.uploadImage(this.imgId,"mobile");
            // }
            if (!(this.sliderImage || this.sliderMobileImage)) {
              this.getData();
              // this.$router.push("/home/trendingSlider");
            }
            this.msg = "Added Sucessfully";
            this.showsnackbar = true;
            this.link = null;
            // this.checkbox = null;
            this.imagePreview = null;
            this.file = null;
            this.dialog = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;
      var user = {};
      user["link"] = this.editingitem.link;
      user["ismiddle"] = true;
      user["istop"] = false;
      user["id"] = this.editingitem;
      axios({
        method: "POST",
        url: "/home/slider/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            if (this.sliderImage) {
              this.uploadImage(this.editingitem._id);
            }
            // if (this.sliderMobileImage) {
            //   this.uploadImage(this.editingitem._id,"mobile");
            // }
            if (!(this.sliderImage || this.sliderMobileImage)) {
              this.getData();
              // this.$router.push("/home/trendingSlider");
            }
          } else {
            this.msg = "Can't Update";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      var data = {};
      data["id"] = r._id;
      axios({
        url: "/home/slider/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.link = null;
      this.dialog = false;
    },
    editSlider(item) {
      this.editingitem = item;
      this.editdialog = true;
    },
    uploadImage(id) {
      let formData = new FormData();
      formData.append("id", id);
      // formData.append("type", type);
      // if(type=='web')
      formData.append("photo", this.sliderImage);
      // if(type=='mobile')
      // formData.append("photo", this.sliderMobileImage);

      axios({
        method: "POST",
        url: "/home/slider/uploadimage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.showsnackbar = true;
            this.msg = "Uploaded Successfully";
            this.imagePreview = null;
            this.file = null;
            this.dialog = false;
          } else {
            this.msg = "Can't Update";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.dash-root { font-family: poppinsmedium, Roboto, sans-serif; padding: 12px 12px; }
.dash-page-header { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 24px; flex-wrap: wrap; gap: 16px; }
.dash-page-header__eyebrow { font-size: 13px; color: #8a93a4; margin: 0 0 4px; font-family: poppinsmedium, sans-serif; text-transform: uppercase; letter-spacing: 0.5px; }
.dash-page-header__title { font-size: 22px; font-weight: 700; color: #1a202c; margin: 0; font-family: poppinsbold, sans-serif; line-height: 1.2; }
.dash-page-header__actions { display: flex; gap: 12px; }

.slider-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 24px; }
.modern-card { background: #ffffff; border: 1px solid #eaedf0; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02) !important; transition: transform 0.2s ease, box-shadow 0.2s ease; }
.modern-card:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06) !important; }

.slider-image-wrapper { height: 140px; background: #f8fafc; overflow: hidden; position: relative; border-bottom: 1px solid #eaedf0; }
.slider-image { width: 100%; height: 100%; object-fit: cover; cursor: pointer; transition: transform 0.3s ease; }
.slider-image:hover { transform: scale(1.03); }

.slider-content { padding: 16px; }
.slider-link { font-size: 13px; color: #64748b; margin-bottom: 16px; font-family: poppinsmedium, sans-serif; word-break: break-all; }
.slider-actions { display: flex; gap: 8px; }

/* Dialog Styles */
::v-deep .modern-dialog { border-radius: 16px !important; overflow: hidden; }
.modern-dialog-card { border-radius: 16px !important; }
.modern-dialog-header { background: #f8fafc; border-bottom: 1px solid #eaedf0; padding: 20px 24px !important; font-family: poppinssemibold, sans-serif; font-size: 18px; color: #1e293b; }
.modern-dialog-close { color: #64748b !important; }
.modern-dialog-body { padding: 24px !important; background: #ffffff; }
.modern-dialog-actions { padding: 16px 24px !important; background: #f8fafc; border-top: 1px solid #eaedf0; }
.btn-cancel { color: #64748b !important; font-family: poppinsmedium, sans-serif; text-transform: none; font-size: 14px; letter-spacing: 0; border-radius: 8px; }
.btn-submit { background: #3ea56e !important; color: #ffffff !important; font-family: poppinsmedium, sans-serif; text-transform: none; font-size: 14px; letter-spacing: 0; border-radius: 8px; padding: 0 24px !important; box-shadow: 0 4px 12px rgba(62, 165, 110, 0.2) !important; }

.modern-input ::v-deep .v-input__control .v-input__slot { border-radius: 8px; }
.image-upload-wrapper { border: 1px dashed #cbd5e1; border-radius: 12px; padding: 16px; background: #f8fafc; }
</style>
